import { Button, Col, Row } from "react-bootstrap";
import { BsSliders, BsDownload } from "react-icons/bs";
import styled from "styled-components";
import { useContext } from "react";
import { FilterReportModal } from "./FilterReportModal";
import { ExportReportModal } from "./ExportReportModal";
import { SecondaryGreenButton } from "../../../components/Buttons/styles";
import { ReportDetailEnum } from "../../../domain/enum/ReportDetailEnum";
import { ReportDetailsContext } from "../../../context/admin/reportDetails/ReportDetailsContext";
import { ProgressReportTable } from "./components/ProgressReportTable";
import { IndicatorsReportTable } from "./components/IndicatorsReportTable";
import { FinancialReportTable } from "./components/FinancialReportTable";
import { PaginationControls } from "./components/PaginationControls";

export function ReportDetailsComponent() {
    const {
        activeTab, setActiveTab,
        syncStatusMessage, isLoadingSyncStatus,
        showFilterModal, setShowFilterModal,
        showExportModal, setShowExportModal,
        reportData, pagination, isLoading, error,
        sortBy, sortDirection, handleSort,
        goToPage, fetchReport,
        indicatorsData, indicatorsPagination, indicatorsLoading, indicatorsError,
        indicatorsSortBy, indicatorsSortDirection, handleIndicatorsSort,
        indicatorsGoToPage, fetchIndicatorsReport,
        financialData, financialPagination, financialLoading, financialError,
        financialSortBy, financialSortDirection, handleFinancialSort,
        financialGoToPage, fetchFinancialReport,
    } = useContext(ReportDetailsContext);

    return(
        <ReportDetailsComponentStyles>
            <Row className="pt-4 header-row align-items-center">
                <Col>
                    <Row className="report-tab-buttons align-items-center">

                        <Col md="auto">
                            <Button className={"px-0 " + (activeTab === ReportDetailEnum.consumptionDetailed ? "active" : "") }
                                onClick={() => setActiveTab(ReportDetailEnum.consumptionDetailed)}
                                style={{backgroundColor:"transparent"}}
                                >
                                Relatório de indicadores
                            </Button>
                        </Col>
                        <Col md="auto">
                            <Button className={"px-0 " + (activeTab === ReportDetailEnum.financial ? "active" : "")}
                                onClick={() => setActiveTab(ReportDetailEnum.financial)}
                                style={{backgroundColor:"transparent"}}
                                >
                                Relatório financeiro
                            </Button>
                        </Col>
                        <Col md="auto">
                            <Button className={"px-0 " + (activeTab === ReportDetailEnum.consumption ? "active" : "")}
                                onClick={() => setActiveTab(ReportDetailEnum.consumption)}
                                style={{backgroundColor:"transparent"}}
                                >
                                Relatório de progresso
                            </Button>
                        </Col>
                    </Row>
                </Col>
                <Col md="auto" className="d-flex align-items-center">
                    <span className="updated-at">
                        {isLoadingSyncStatus ? "Carregando..." : syncStatusMessage}
                    </span>
                </Col>
                {(activeTab === ReportDetailEnum.consumption || activeTab === ReportDetailEnum.consumptionDetailed || activeTab === ReportDetailEnum.financial) && (
                    <>
                        <Col md="auto" className="d-flex align-items-center action-buttons ml-auto">
                            <SecondaryGreenButton className="px-3" onClick={() => setShowFilterModal(true)}>
                                Filtro <BsSliders className="ms-1" />
                            </SecondaryGreenButton>
                        </Col>
                        <Col xs="auto" className="d-flex align-items-center action-buttons">
                            <SecondaryGreenButton className="px-3" onClick={() => setShowExportModal(true)}>
                                Exportar <BsDownload className="ms-1" />
                            </SecondaryGreenButton>
                        </Col>
                    </>
                )}
            </Row>

            {activeTab === ReportDetailEnum.consumption && (
                <div className="progress-report-content">
                    <ProgressReportTable
                        data={reportData}
                        sortBy={sortBy}
                        sortDirection={sortDirection}
                        onSort={handleSort}
                        isLoading={isLoading}
                        error={error}
                        onRetry={fetchReport}
                    />
                    {!isLoading && !error && (
                        <PaginationControls
                            currentPage={pagination.currentPage}
                            totalPages={pagination.totalPages}
                            onPageChange={goToPage}
                        />
                    )}
                </div>
            )}

            {activeTab === ReportDetailEnum.consumptionDetailed && (
                <div className="progress-report-content">
                    <IndicatorsReportTable
                        data={indicatorsData}
                        sortBy={indicatorsSortBy}
                        sortDirection={indicatorsSortDirection}
                        onSort={handleIndicatorsSort}
                        isLoading={indicatorsLoading}
                        error={indicatorsError}
                        onRetry={fetchIndicatorsReport}
                    />
                    {!indicatorsLoading && !indicatorsError && (
                        <PaginationControls
                            currentPage={indicatorsPagination.currentPage}
                            totalPages={indicatorsPagination.totalPages}
                            onPageChange={indicatorsGoToPage}
                        />
                    )}
                </div>
            )}

            {activeTab === ReportDetailEnum.financial && (
                <div className="progress-report-content">
                    <FinancialReportTable
                        data={financialData}
                        sortBy={financialSortBy}
                        sortDirection={financialSortDirection}
                        onSort={handleFinancialSort}
                        isLoading={financialLoading}
                        error={financialError}
                        onRetry={fetchFinancialReport}
                    />
                    {!financialLoading && !financialError && (
                        <PaginationControls
                            currentPage={financialPagination.currentPage}
                            totalPages={financialPagination.totalPages}
                            onPageChange={financialGoToPage}
                        />
                    )}
                </div>
            )}

            <FilterReportModal
                show={showFilterModal}
                showModuleDates={activeTab === ReportDetailEnum.consumptionDetailed || activeTab === ReportDetailEnum.consumption}
                onClose={() => setShowFilterModal(false)}
            />

            <ExportReportModal
                show={showExportModal}
                activeTabLabel={tabLabels[activeTab]}
                onClose={() => setShowExportModal(false)}
            />
        </ReportDetailsComponentStyles>
    )
}

const tabLabels: Record<ReportDetailEnum, string> = {
    [ReportDetailEnum.consumptionDetailed]: "Indicadores",
    [ReportDetailEnum.financial]: "Financeiro",
    [ReportDetailEnum.consumption]: "Progresso",
}


const ReportDetailsComponentStyles = styled(Col)`
    background-color:rgba(185, 184, 184, 0.116);
    min-height:91.1vh;
    min-width: 0;

    .updated-at {
        font-size: 1rem;
        color: #7A7A7A;
        white-space: nowrap;
    }
    .action-buttons button {
        font-size: 2vmin;
        padding: 0.5rem 1.25rem;
        i {
            font-size: 2.5vmin;
        }
    }
    .progress-report-content {
        background-color: #FFFFFF;
        padding: 0 0.5rem;
        margin: 0 -15px;
        min-width: 0;
        overflow: hidden;
    }

    .row.report-tab-buttons{
        background-color: transparent!important;
        button{
            background-color: transparent!important;
            border: none !important;
            box-shadow: none !important;
            font-size: 2vmin;
            color: #514F4E!important;
            font-family: Lato;
            font-style: normal;
            font-weight: normal;
            font-size: 2vmin;
            line-height: 24px;
            padding-bottom: 0.5rem;
            &.active {
                background-color: transparent!important;
                font-weight: 700;
                border-bottom: 3px solid #D9534F !important;
            }
            &:hover, &:active, &:focus{
                background-color: transparent !important;
            }
        }
    }
`
